import { useState } from 'react';
import { CasMRTable, CasMRTableExportOptionMenu, CasMRTCellRenderLink, ICasMRTCellProps } from 'src/compass/shared/components';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import ClaimDetailsDialog from './ClaimDetailsDialog';

export default function DataTab() {
  const queryResult = useRetrieve({ url: 'Sce/Claims/Data' });
  const [dialogRowId, setDialogRowId] = useState<any>(null);

  return (
    <>
      <CasMRTable
        queryResult={queryResult}
        createColumnsFromData
        overrideColumns={{
          insuredName: {
            Cell: (props: ICasMRTCellProps) => (
              <CasMRTCellRenderLink {...props} onClick={(row) => setDialogRowId(row.id)} />
            ),
          },
          policyNumber: { header: 'Policy#' },
          totalNumberInsured: { header: 'HC' },
          targetCWT: { header: 'Target CWT' },
          costPerHead: { header: 'Cost/Head' },
          costPerCWT: { header: 'Cost/CWT' },
          basePremium: { header: 'Total Premium' },
          netPremium: { header: 'Producer Premium' },
          hasClaim: { header: 'Has Claim?' },
          indemnityPerCWT: { header: 'Indemnity/CWT' },
          netIndemnityPerCWT: { header: 'Net Indemnity/CWT' },
          claimDueByDate: { header: 'Claim Due By' },
          noticeSentUser: { header: 'Notice By' },
          noticeSentDate: { header: 'Notice Sent' },
          claimReceivedDate: { header: 'Received' },
          claimReceivedUser: { header: 'Rcvd By' },
          claimAttachedDate: { header: 'Attached' },
          claimAttachedUser: { header: 'Attached By' },
          claimRejectedDate: { header: 'Rejected' },
          claimReviewedDate: { header: 'Reviewed' },
          claimNumber: { header: 'Claim#' },
          isFwdContract: { header: 'Is Fwd Contract?' },
        }}
        renderTopToolbarCustomActions={() => CasMRTableExportOptionMenu('Sce/Claims/Data')}
      />
      {dialogRowId && (
        <ClaimDetailsDialog
          id={dialogRowId}
          onClose={() => {
            setDialogRowId(null);
            queryResult.refetch();
          }}
        />
      )}
    </>
  );
}
